import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faListUl } from '@fortawesome/free-solid-svg-icons';

import './agenda.css';

const Agenda = () => {
  return (
    <div className="giswnauce__agenda">
        <div className="giswnauce__agenda-container">
            <span className="anchor-agenda" id="giswnauce_agenda"></span>
            <div className="agenda-container_header">
                <p><FontAwesomeIcon icon={faListUl} /></p><h1>Program Konferencji</h1>
            </div>
            <div className="agenda-container_subheader">
                <h2>24 września 2026 (Dzień 1)</h2>
            </div>
            <div className="agenda-container_description first_table">
                <table>
                    <thead>
                        <tr>
                            <th>Godziny</th>
                            <th>Element konferencji</th>
                            <th>Czas trwania</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>08:00 - 09:00</td>
                            <td>Rejestracja uczestników</td>
                            <td>1h</td>
                        </tr>
                        <tr>
                            <td>09:00 - 11:00</td>
                            <td>Sesja inauguracyjna</td>
                            <td>2h</td>
                        </tr>
                        <tr>
                            <td>11:00 - 11:30</td>
                            <td>Przerwa kawowa</td>
                            <td>30min</td>
                        </tr>
                        <tr>
                            <td>11:30 - 13:00</td>
                            <td>Sesje tematyczne 1, 2</td>
                            <td>1h 30min</td>
                        </tr>
                        <tr>
                            <td>13:00 - 14:00</td>
                            <td>Obiad</td>
                            <td>1h</td>
                        </tr>
                        <tr>
                            <td>14:00 - 15:00</td>
                            <td>Sesja posterowa</td>
                            <td>1h</td>
                        </tr>
                        <tr>
                            <td>15:00 - 17:00</td>
                            <td>Sesja terenowa (zwiedzanie jeziora Ukiel)</td>
                            <td>2h</td>
                        </tr>
                        <tr>
                            <th colSpan="3">Po konferencji</th>
                        </tr>
                        <tr>
                            <td>20:00 - 24:00</td>
                            <td>Uroczysta kolacja</td>
                            <td>4h</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="agenda-container_subheader">
                <h2>25 września 2026 (Dzień 2)</h2>
            </div>
            <div className="agenda-container_description second_table">
            <table>
                    <thead>
                        <tr>
                            <th>Godziny</th>
                            <th>Element konferencji</th>
                            <th>Czas trwania</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>09:00 - 10:30</td>
                            <td>Sesja tematyczna 3, 4</td>
                            <td>1h 30min</td>
                        </tr>
                        <tr>
                            <td>10:30 - 11:00</td>
                            <td>Przerwa kawowa</td>
                            <td>30min</td>
                        </tr>
                        <tr>
                            <td>11:00 - 13:00</td>
                            <td>Sesje tematyczne 5, 6</td>
                            <td>2h</td>
                        </tr>
                        <tr>
                            <td>13:00 - 14:00</td>
                            <td>Obiad</td>
                            <td>1h</td>
                        </tr>
                        <tr>
                            <td>14:00 - 15:30</td>
                            <td>Warsztaty / Sesja specjalna</td>
                            <td>1h 30min</td>
                        </tr>
                        <tr>
                            <td>15:30 - 16:00</td>
                            <td>Przerwa kawowa</td>
                            <td>30min</td>
                        </tr>
                        <tr>
                            <td>16:00 - 17:00</td>
                            <td>Zakończenie konferencji</td>
                            <td>1h</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div> 
    </div>
  )
}

export default Agenda